module.exports = __webpack_public_path__ + "img/wegow-conciertos.ff16a60c.svg";